// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1zMgT","productName":"Table_productName__-Px0P"};